<template>
  <ValidationField
    v-slot="{ field, errors }"
    v-model="inputValue"
    :name="name"
    as="div"
    :rules="rules"
    :vid="vid"
  >
    <vs-input
      v-bind="field"
      v-model="inputValue"
      :class="className"
      :danger="errors.length > 0"
      :danger-text="errors[0]"
      icon-no-border
      icon="icon icon-home"
      icon-pack="feather"
      :label="label || name"
    />
  </ValidationField>
</template>

<script>
export default {
  name: 'StoreNameField',
  props: {
    modelValue: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: 'ストア名'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    },
    className () {
      return {
        'w-full': this.fullWidth
      }
    }
  }
}
</script>

<style scoped>

</style>
